export default {
  path: '/test-qr',
  meta: {
    title: '测试扫码',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/test-qr`),
}



// WEBPACK FOOTER //
// ./src/views/testQr/router.js